import React from "react";
import { Box, Typography } from "@mui/material";

import { doctorListsResponse } from "../../../models/practice.model";

import UserListsStyles from "../PracticeLists.module.css";
interface userTableRowProps {
    data: doctorListsResponse,
    userIndex: number
}

const PracticeAssociatedDoctorsTableRow = ({ data, userIndex }: userTableRowProps) => {
    const { FullName, EmailAddress, OccupationName, RoleName, SubcategoryName } = data! || {};

    const cellClassName = !(userIndex % 2) ? UserListsStyles.practiceListTableOddCell : UserListsStyles.practiceListTableEvenCell;

    return (
        <Box className={UserListsStyles.practiceListTableRow} display={'contents'}>
            <Box className={cellClassName}>
                <Typography>{FullName || ''}</Typography>
            </Box>
            <Box className={cellClassName}>
                <Typography>{EmailAddress || ''}</Typography>
            </Box>
            <Box className={cellClassName}>
                <Typography>{OccupationName || ''}</Typography>
            </Box>
            <Box className={cellClassName}>
                <ul>
                    {SubcategoryName?.length ? (
                        SubcategoryName.map((subcategory, idx) => (
                            <li key={idx}>
                                <Typography>{subcategory}</Typography>
                            </li>
                        ))
                    ) : (
                        <Typography>-</Typography>
                    )}
                </ul>
            </Box>
            <Box className={cellClassName}>
                <Typography>{RoleName || ''}</Typography>
            </Box>
        </Box>
    );
}

export default PracticeAssociatedDoctorsTableRow